import { render, staticRenderFns } from "./PromoCodeUsages.vue?vue&type=template&id=c91d7ec6&"
import script from "./PromoCodeUsages.vue?vue&type=script&lang=js&"
export * from "./PromoCodeUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports